import React from 'react';

import PropTypes from 'prop-types';

import { motion } from 'framer-motion';

// Tasteful on-scroll reveal used across the redesigned pages. Fades + lifts the
// content into place once, when it first enters the viewport. `delay` lets a
// group of siblings stagger in.
const Reveal = ({ children, delay = 0, y = 24, ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: '-60px' }}
    transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1], delay }}
    {...rest}
  >
    {children}
  </motion.div>
);

Reveal.propTypes = {
  children: PropTypes.node,
  delay: PropTypes.number,
  y: PropTypes.number,
};

export default Reveal;
